import { render } from "./SearchSelector.vue?vue&type=template&id=2bcd758f&scoped=true"
import script from "./SearchSelector.vue?vue&type=script&lang=js"
export * from "./SearchSelector.vue?vue&type=script&lang=js"

import "./SearchSelector.vue?vue&type=style&index=0&id=2bcd758f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcd758f"]])

export default __exports__